module.exports = __webpack_public_path__ + "static/media/hotel-4.c72dcf35.jpg";